import { helpers } from "vuelidate/lib/validators";
import moment from "moment";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Moment.js based minimum date validator
 */
export const minDateValidator = (minDate: string) =>
  helpers.withParams(
    {
      type: "minDate",
      value: minDate
    },
    (value: string) => {
      return moment(value).isSameOrAfter(minDate);
    }
  );
